import {z} from 'zod';
import {AgentResultReference} from './orchestration.ts';

export const AgentQualityCheck=z.enum(['style','technical','evidence','delivery']);
export type AgentQualityCheck=z.infer<typeof AgentQualityCheck>;
export const AgentQualityStatus=z.enum(['passed','failed','unverified']);
export const AgentQualityReport=z.strictObject({
 version:z.literal(1),target_references:z.array(AgentResultReference).min(1).max(30),
 checks:z.strictObject({
  style:z.strictObject({status:AgentQualityStatus,detail:z.string().trim().min(10).max(2000)}),
  technical:z.strictObject({status:AgentQualityStatus,detail:z.string().trim().min(10).max(2000)}),
  evidence:z.strictObject({status:AgentQualityStatus,detail:z.string().trim().min(10).max(2000)}),
  delivery:z.strictObject({status:AgentQualityStatus,detail:z.string().trim().min(10).max(2000)}),
 }),
 verdict:z.enum(['pass','revise']),
 defects:z.array(z.strictObject({check:AgentQualityCheck,issue:z.string().trim().min(10).max(1500),repair:z.string().trim().min(10).max(1500),reference:AgentResultReference.optional()})).max(20),
 // Persisted original sources actually inspected, never an invented future QA ID.
 evidence_references:z.array(z.strictObject({kind:z.enum(['revision','evidence','report']),id:z.uuid()})).min(1).max(120),
}).refine(r=>r.verdict==='pass'
 ? Object.values(r.checks).every(c=>c.status==='passed')&&r.defects.length===0
 : Object.values(r.checks).some(c=>c.status!=='passed')&&r.defects.length>0,
 {message:'Aprobar exige cuatro comprobaciones acreditadas; reparar exige defectos accionables.'})
 .refine(r=>JSON.stringify(r).length<=24000,{message:'Integra la revisión en un máximo de veinticuatro mil caracteres JSON.'});
export type AgentQualityReport=z.infer<typeof AgentQualityReport>;
